import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';

const Footer = () => {
  return (
    <footer>
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          textAlign: 'center',
          py: 2,
        }}
      >
        <Typography variant="body2">
          © 2025 Ministry of Education Ethiopia. All rights reserved.
        </Typography>

        <Box
          sx={{
            mt: 0.5,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Typography
            variant="body2"
            component="a"
            href="https://t.me/moeexitexamofficial"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none', color: 'inherit' }}
          >
            <u>Join Help and Support Group</u>
          </Typography>

          <IconButton
            color="inherit"
            component="a"
            href="https://t.me/moeexitexamofficial"
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ p: 0.5 }}
          >
            <TelegramIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
